import React, {useEffect,useState } from "react";
import Chart from "react-apexcharts";
import { Box, Typography, MenuItem, Select } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchStockDashboardData } from "../../../../redux/reducers/stockDashboardSlice";
const SalesPurchasesReturns = () => {
  const dispatch = useDispatch();
  const { saleVsReturns, purchaseVsReturns, loading } = useSelector(
    (state) => state.stockDashboard
  );
  const [year, setYear] = useState("2025");
  const [saleData, setSaleData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);

  useEffect(() => {
    dispatch(fetchStockDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!saleVsReturns || !purchaseVsReturns) return;

    setSaleData(saleVsReturns[year] || []);
    setPurchaseData(purchaseVsReturns[year] || []);
  }, [saleVsReturns, purchaseVsReturns, year]);

  const getSalesChartData = () => {
    return {
      series: [
        {
          name: "Sales",
          data: saleData.map((item) => ({
            x: item.month,
            y: item.total,
            count: item.count,
          })),
        },
        {
          name: "Returns",
          data: saleData.map((item) => ({
            x: item.month,
            y: item.returnTotal,
            count: item.returnCount,
          })),
        },
      ],
      options: {
        chart: { type: "bar", height: 350, toolbar: { show: false } },
        colors: ["#0B4DF5", "#F94144"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "40%",
            borderRadius: 4,
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: saleData.map((item) => item.month),
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          markers: { radius: 12 },
        },
        fill: { opacity: 1 },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const point = w.config.series[seriesIndex].data[dataPointIndex];
            return `
              <div style="padding:8px">
                <strong>${point.x}</strong><br/>
                ${w.config.series[seriesIndex].name}: ₹${point.y.toLocaleString()}<br/>
                Count: ${point.count}
              </div>
            `;
          },
        },
      },
    };
  };

  const getPurchaseChartData = () => {
    return {
      series: [
        {
          name: "Purchases",
          data: purchaseData.map((item) => ({
            x: item.month,
            y: item.total,
            count: item.count,
          })),
        },
        {
          name: "Returns",
          data: purchaseData.map((item) => ({
            x: item.month,
            y: item.returnTotal,
            count: item.returnCount,
          })),
        },
      ],
      options: {
        chart: { type: "bar", height: 350, toolbar: { show: false } },
        colors: ["#2EB67D", "#F94144"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "40%",
            borderRadius: 4,
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: purchaseData.map((item) => item.month),
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
        fill: { opacity: 1 },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const point = w.config.series[seriesIndex].data[dataPointIndex];
            return `
              <div style="padding:8px">
                <strong>${point.x}</strong><br/>
                ${w.config.series[seriesIndex].name}: ₹${point.y.toLocaleString()}<br/>
                Count: ${point.count}
              </div>
            `;
          },
        },
      },
    };
  };

  if (loading && !saleData.length && !purchaseData.length)
    return <Box p={3}>Loading...</Box>;

  return (
    <Box display="flex" gap={4} p={4} bgcolor="#f9f9fb" flexWrap="wrap">
      {/* Sales vs Returns */}
      <Box sx={{ 
        flex: 1, 
        minWidth: 450, 
        bgcolor: "white", 
        borderRadius: 3, 
        boxShadow: 1, 
        p: 3 
      }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={600}>Sales vs Returns</Typography>
          <Select value={year} size="small" onChange={(e) => setYear(e.target.value)}>
            {["2023", "2024", "2025", "2026"].map((y) => (
              <MenuItem key={y} value={y}>{y}</MenuItem>
            ))}
          </Select>
        </Box>
        <Chart {...getSalesChartData()} type="bar" height={300} />
      </Box>

      {/* Purchases vs Returns */}
      <Box sx={{ 
        flex: 1, 
        minWidth: 450, 
        bgcolor: "white", 
        borderRadius: 3, 
        boxShadow: 1, 
        p: 3 
      }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={600}>Purchases vs Returns</Typography>
          <Select value={year} size="small" onChange={(e) => setYear(e.target.value)}>
            {["2023", "2024", "2025", "2026"].map((y) => (
              <MenuItem key={y} value={y}>{y}</MenuItem>
            ))}
          </Select>
        </Box>
        <Chart {...getPurchaseChartData()} type="bar" height={300} />
      </Box>
    </Box>
  );
};

export default SalesPurchasesReturns;